// src/state/customers/selectedMode/types.ts
var CustomerAddressType = /* @__PURE__ */ ((CustomerAddressType2) => {
  CustomerAddressType2["HOUSE"] = "house";
  CustomerAddressType2["HOTEL"] = "hotel";
  CustomerAddressType2["OFFICE"] = "office";
  CustomerAddressType2["APARTMENT"] = "apartment";
  return CustomerAddressType2;
})(CustomerAddressType || {});
var customerAddressTypeOptions = [
  "house" /* HOUSE */,
  "hotel" /* HOTEL */,
  "office" /* OFFICE */,
  "apartment" /* APARTMENT */
];
var ICardType = /* @__PURE__ */ ((ICardType2) => {
  ICardType2["MASTER_CARD"] = "MasterCard";
  ICardType2["VISA"] = "Visa";
  ICardType2["AMERICAN_EXPRESS"] = "AmericanExpress";
  return ICardType2;
})(ICardType || {});
var CustomersTypes = /* @__PURE__ */ ((CustomersTypes2) => {
  CustomersTypes2["MASTER_CUSTOMERS"] = "master";
  CustomersTypes2["LOCATION_CUSTOMERS"] = "location";
  CustomersTypes2["REMOTE_LOCATION_CUSTOMERS"] = "remoteLocation";
  return CustomersTypes2;
})(CustomersTypes || {});
var SET_SELECTED_CUSTOMERS_MODE = "SET_SELECTED_CUSTOMERS_MODE";
var SET_SELECTED_CUSTOMERS_MODE_WS = "SET_SELECTED_CUSTOMERS_MODE_WS";

export { CustomerAddressType, CustomersTypes, ICardType, SET_SELECTED_CUSTOMERS_MODE, SET_SELECTED_CUSTOMERS_MODE_WS, customerAddressTypeOptions };
